import React from 'react'
import * as d3 from 'd3'
import { connect } from 'react-redux'
import { mobileCheck, getResume, wrap } from '../helpers/utils'
import  * as actions from '../actions/TimeLineActions'
import 'materialize-css'

class TimeLine extends React.Component{
  constructor(props){
    super(props)
    this.initTimeLine = this.initTimeLine.bind(this)
    this.addTimelineTitles = this.addTimelineTitles.bind(this)
    this.getChartComponents = this.getChartComponents.bind(this)
    this.resizeHandler = this.resizeHandler.bind(this)
  }

  shouldComponentUpdate(){
    return false
  }

  componentDidMount(){
    this.initTimeLine()
  }

  componentWillMount(){
    window.addEventListener('resize', this.resizeHandler)
    document.addEventListener('orientationchange', this.resizeHandler)
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.resizeHandler)
    document.removeEventListener('orientationchange', this.resizeHandler)
  }

  getChartComponents(){
    let mobile = mobileCheck()
    let height = 1300
    let margin

    // Set margin
    if (mobile){
      margin = {left:0, right:0, top:70, bottom:10}
    }
    else{
      margin = {left:70, right:50, top:70, bottom:50}
    }

    let width = document.getElementById('timeline').clientWidth - margin.left - margin.right
    let x = d3.scaleLinear().domain([-5,5]).range([0, width])
    let yExtent = [d3.min(this.props.resume, (d)=>{return d.startDate}), d3.max(this.props.resume, (d)=>{return d.endDate})]
    let y = d3.scaleTime().domain(yExtent).range([height, 0])

    let ticks = this.props.resume.map(function(d){return d.startDate})
    ticks.splice(ticks.length-5,1) // Remove two very close ticks
    ticks.push(new Date(2016,11,20)) // Add end of MS
    ticks.push(new Date(2015,0,5)) // Add end of LY
    return{
      margin:margin,
      eduWidth:4,
      jobWidth:4,
      x: x,
      y: y,
      wrapFactor: (x(4) - x(0)) * .9,
      height: height,
      xAxis: d3.axisBottom(x),
      yAxis: d3.axisLeft(y).tickFormat(d3.timeFormat('%b %Y')).tickSizeOuter(0).tickValues(ticks),
      width:width
    }


  }

  render(){
    return(
        <div id="timeline">
        </div>
    )
  }


  initTimeLine(){
    const chartComponents = this.getChartComponents()
    const margin = chartComponents.margin
    const eduWidth = chartComponents.eduWidth
    const jobWidth = chartComponents.jobWidth
    const x = chartComponents.x
    const y = chartComponents.y
    const xAxis = chartComponents.xAxis
    const yAxis = chartComponents.yAxis
    const height = chartComponents.height
    const wrapFactor = chartComponents.wrapFactor
    const width = chartComponents.width

    
    
    let data = this.props.resume
    const jobs = data.map(function(d){return d.job})

    const colorDomain = ["#96B042", 
                         "#DF5744",
                         "#863273",
                         "#7860D1",
                         "#A85F3E",
                         "#316099",
                         "#EEB21A",
                         "#1A896E",
                         "#7759A3",
                        ]


    const color = d3.scaleOrdinal(colorDomain).domain(jobs)

    const svg = d3.selectAll('#timeline')
                .append('svg')
                .attr('height', margin.top+margin.bottom+height)
                .attr('width', margin.left+margin.right+width)
                .append('g')
                .attr('transform', `translate(${margin.left},${margin.top})`)

    // Add axes
    svg.append('g')
       .attr('class', 'x axis hiddenAxis')
       .attr('transform', `translate(0, ${height})`)
       .call(xAxis)

    svg.append('g')
       .attr('class', 'y axis')
       .attr('transform', `translate(${x(0)},0)`)
       .call(yAxis)


    // Add text
    svg.selectAll('.job')
       .data(data)
       .enter()
       .append('g')
       .attr('class', 'job-desc')
       .append('text')
       .attr('class', 'job-desc-text')
       .text((d, i)=>{return d.job})
       .attr('x', (d)=>{ 
        if (d.type=="edu")
          return x(-eduWidth) +5
        else
            return x(0.2)
        })
       .attr('y', (d)=>{
          return y(new Date((d.startDate.getTime() + d.endDate.getTime())/2.) )
        })
       .attr('dy',0)
       .each(function(d){
          var t = d3.select(this)
          if (d.type=="edu")
            wrap(t, wrapFactor*.75)
          else
            d.id==6?wrap(t,wrapFactor/2):wrap(t,wrapFactor)
       })

    const _this = this
    // Add rectangles
    svg.selectAll('.job-desc')
       .append('rect')
       .attr('class','job-rect')
       .attr('rx', 5)
       .attr('ry', 5)
       .attr('x', (d)=>{
         return d.type=="job"?x(0):x(-eduWidth)})
       .attr('width', function(d){
         if (d.type=='edu')
          return x(eduWidth)-x(0)
         else
          return d.id==6?x(jobWidth*.75)-x(0):x(jobWidth)-x(0)
        })
       .attr('y', (d)=>{return y(d.endDate)})
       .attr('height', (d)=>{return y(d.startDate)-y(d.endDate)})
       .style('fill', (d)=>{return color(d.job)})
       .style('opacity', 0.5)
       .style('stroke','black')
       .style('stroke-width','0px')
       .on('click', function(d){
          _this.props.showJobDetails(d.id)
          d3.selectAll('rect').transition().duration(500).style('stroke-width','0px')
          d3.select(this).transition().duration(500).style('stroke-width','3px')
       })


    this.addTimelineTitles(svg, margin, x, y, true)
  }

  resizeHandler(){
    const chartComponents = this.getChartComponents()
    const margin = chartComponents.margin
    const eduWidth = chartComponents.eduWidth
    const jobWidth = chartComponents.jobWidth
    const x = chartComponents.x
    const y = chartComponents.y
    const xAxis = chartComponents.xAxis
    const yAxis = chartComponents.yAxis 
    const height = chartComponents.height
    const wrapFactor = chartComponents.wrapFactor
    const width = chartComponents.width

    
    
    const svg = d3.select('#timeline').select('svg')
                  .attr('width', margin.left+margin.right+width)
                  .select('g')
                  .attr('transform', `translate(${margin.left},${margin.top})`)

    // Redraw axes
    svg.select('.x.axis')
       .attr('transform', `translate(0, ${height})`)
       .call(xAxis)

    svg.select('.y.axis')
       .attr('transform', `translate(${x(0)},0)`)
       .call(yAxis)

    // Resize rects
    svg.selectAll('.job-rect')
       .attr('width', function(d){
          if (d.type=='edu')
            return x(eduWidth)-x(0)
          else
            return d.id==6?x(jobWidth*.75)-x(0):x(jobWidth)-x(0)
        })
       .attr('x', (d)=>{
         return d.type=="job"?x(0):x(-eduWidth)
       })

    // Resize text
    svg.selectAll('.job-desc-text')
       .text((d)=>{return d.job})
       .attr('x', (d)=>{ 
        if (d.type=="edu")
          return x(-eduWidth) +5
        else
            return x(0.2)
        })
       .attr('y', (d)=>{
          return y(new Date((d.startDate.getTime() + d.endDate.getTime())/2.) )
        })
       .attr('dy', 0)
       .each(function(d){
          var t = d3.select(this)
          if (d.type=="edu")
            wrap(t, wrapFactor*.75)
          else
            d.id==6?wrap(t,wrapFactor/2):wrap(t,wrapFactor)
       })

       this.addTimelineTitles(svg,margin,x,y,true)
       

  }


  /** Adds the education and experience labels on top of the timeline
  * svg: the svg element of the timeline
  * margin: the svg margin object
  * x The x scal of the chart
  * y The y scal of the chart
  */
  addTimelineTitles(svg, margin, x, y, offsetOnly=false){
    if (!offsetOnly){
      svg.append('text')
         .attr('class', 'timeline-header')
         .text("Education")
         .attr('x', x(-4))
         .attr('y', y(y.domain()[1])-margin.top/2.)


      svg.append('text')
         .attr('class', 'timeline-header')
         .text("Experience")
         .attr('x', x(4))
         .attr('y', y(y.domain()[1])-margin.top/2.)
    }


  // Get text width
  let widths = {}
  let texts = document.getElementsByClassName('timeline-header')
  for (let i=0; i<texts.length; i++)
    widths[d3.select(texts[i]).text()] = texts[i].clientWidth

 
  // Compute offsets
  let offsets = {}
  let keys = Object.keys(widths)
  for (let i=0; i<keys.length; i++)
    offsets[keys[i]] = (x(4) - x(0) - widths[keys[i]])/2


  svg.selectAll('.timeline-header')
     .attr('x', function(){
        let currentText = d3.select(this).text()
        if (currentText=='Education')
          return x(-4) + offsets[currentText]
        return x(0) + offsets[currentText]
     })
  }

}

function mapStateToProps(state){
  return state.ResumeReducer
}

function mapDispatchToProps(dispatch){
  return{
    showJobDetails: (p)=>{dispatch(actions.showSelectedJob(p)) }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TimeLine)


// WEBPACK FOOTER //
// ./app/components/TimeLine.js